__turbopack_context__.v({
  "list": "_0pLfgq_list",
  "participantItem": "_0pLfgq_participantItem",
  "participantName": "_0pLfgq_participantName",
  "participantPrice": "_0pLfgq_participantPrice",
  "section": "_0pLfgq_section",
});
